import { Box, PressableOpacity } from "app/components/common";
import normalize from "app/utils/normalize";
import React from "react";
import FastImage from "react-native-fast-image";

export const StarImage = require("../../../../../assets/images/3d-star.png");
export const EmptyStarImage = require("../../../../../assets/images/3d-star-empty.png");

export interface IRatingStarProps {
  isFill: boolean;
  setRating: () => void;
  height?: number;
  width?: number;
}

const RatingStar = ({
  isFill,
  setRating,
  height = normalize(60),
  width = normalize(50),
}: IRatingStarProps) => {
  return (
    <PressableOpacity onPress={setRating}>
      <Box
        height={height}
        width={width}
        justifyContent="center"
        alignItems="center"
      >
        <FastImage
          source={isFill ? StarImage : EmptyStarImage}
          style={{
            height: height,
            width: width,
          }}
        />
      </Box>
    </PressableOpacity>
  );
};

export default RatingStar;
